module.exports = __webpack_public_path__ + "static/media/el-ementa@2x.3ad1ee70.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/network/el-ementa@2x.png
// module id = 653
// module chunks = 0